export { default } from './Flags';
